import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { SupportTypeCellRenderer } from "../column-def-cell-renderers/SupportTypeCellRenderer";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { resourceUnusedSinceCellRenderer } from "../common/resourceUnusedSinceCellRenderer";
import { FilteredSqlResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const sqlColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Database Id", "provider_unique_identifier"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("sql"),

  {
    field: "resource.support_type",
    headerName: "Support Type",
    cellRenderer: ({ data }: ICellRendererParams<FilteredSqlResourceItem>) => {
      return (
        <SupportTypeCellRenderer supportType={data?.resource?.support_type} />
      );
    },
  },

  resourceAccountColumnDef,

  resourceUnusedSinceCellRenderer,

  getResourceMetricsColumnDef("CPU Max", "cpu_max", "sql"),
  getResourceMetricsColumnDef("Connections", "total_connection_sum", "sql"),

  {
    field: "resource.multi_az",
    headerName: "High Availability",
    cellRenderer: ({ data }: ICellRendererParams<FilteredSqlResourceItem>) => {
      return (
        <Typography variant="body2">
          {data?.resource?.multi_az ? "Enabled" : "Disabled"}
        </Typography>
      );
    },
  },

  resourceTotalSpendColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  { field: "resource.type", headerName: "Instance Type" },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
